import { ReactNode } from 'react';
import { Sub, SubContent, SubTrigger, Item } from '@radix-ui/react-dropdown-menu';
import { THEME } from '@anytag/shared-constants';
import { DropdownOption } from '@anytag/shared-types';
import { cn } from '@anytag/shared-utils';
import { Icon } from '../Icon';
import { TextCutter } from '../TextCutter';

export interface MenuItemWithCheckBoxProps<T extends DropdownOption> {
  label?: ReactNode;
  className?: string;
  value?: string | null;
  submenu?: T[];
  onClickSubmenu?: (option: T) => void;
}

export const MultiLevelMenu = <T extends DropdownOption>(props: MenuItemWithCheckBoxProps<T>) => {
  const { label, value = null, submenu = [], onClickSubmenu, className } = props;

  return (
    <Sub>
      <SubTrigger
        asChild
        css={{ '&[aria-expanded="true"]': { outline: 'none', backgroundColor: THEME.background.colors.gray.lv1 } }}
      >
        <Item
          key={value}
          id={value || undefined}
          className="flex cursor-pointer items-center p-2.5 text-base font-normal hover:bg-light-gray hover:outline-none"
        >
          {typeof label === 'string' ? <TextCutter text={label} /> : label}
          <Icon icon="caret-right" size="10px" variant="gray" css={{ marginLeft: 'auto' }} />
        </Item>
      </SubTrigger>
      <SubContent className={cn('rounded-sm bg-white menu-filter-shadow', className)}>
        {submenu.map((s) => (
          <Item
            key={s.value}
            id={s.value}
            onClick={() => {
              onClickSubmenu?.(s);
            }}
            className="flex cursor-pointer items-center gap-2 p-2.5 text-base font-normal hover:bg-light-gray hover:outline-none"
          >
            {s.prefixIcon}
            {typeof s.label === 'string' ? <TextCutter text={s.label} id={s.gtmId} /> : s.label}
          </Item>
        ))}
      </SubContent>
    </Sub>
  );
};
